import { useState, useEffect } from 'react';

export const useConfigurationSchema = (
    redAppName: string | undefined,
    configurations: any
) => {
    const [schemaObject, setSchemaObject] = useState<any>(undefined);
    const [useFormModeActive, setUseFormModeActive] = useState<boolean>(false);

    useEffect(() => {

        setSchemaObject({});
        setUseFormModeActive(false);

        if (!redAppName) return;

        configurations.getSchema(redAppName)
            .then((schema: string) => {
                if (schema) {
                    setSchemaObject(JSON.parse(schema));
                    setUseFormModeActive(true);
                } else {
                    setSchemaObject(undefined);
                    setUseFormModeActive(false);
                }
            })
            .catch((error: Error) => {
                console.error('Failed to fetch schema:', error);
                setUseFormModeActive(false);
            });
    }, [redAppName, configurations]);

    return { schemaObject, useFormModeActive };
};